import { SelectHookFlex } from "../../../../reactHookForm/SelectHookFlex";
import { InputHookFlex } from "../../../../reactHookForm/InputHookFlex";
import { objectStatus } from "../../../../../utils/objectSelect";
import Format from "../../../../../Services/Format";
import DateUtils from "../../../../../Services/DateUtils";
import { useAppSelector } from "../../../../../redux/store";
import { IStore } from "../../../../../redux/features/userMe/interface";
import * as S from "../styled";
import type { IStock } from "../../../../../redux/features/count/interface";

interface IProps {
  register: any;
  control: any;
  watch: any;
  setValue: any;
  setError: any;
  errors: any;
  reset: any;
  openFilter: boolean;
}

export function InputFilter({
  register,
  control,
  watch,
  setValue,
  setError,
  reset,
  openFilter,
}: IProps) {
  const periodoState = watch("typedate");
  const count = useAppSelector(({ countReducer }) => countReducer.value);

  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);

  return (
    <S.Wrapper>
      {openFilter && (
        <div className="min-screen">
          <label>
            <span className="label">Loja</span>
            <SelectHookFlex
              register={register}
              control={control}
              defaultValue={[]}
              name="store"
              placeholder="Loja"
              options={
                storeMe &&
                storeMe?.user?.relationships?.stores?.map((item: IStore) => ({
                  value: item.id,
                  label: item.trading_name || item.company_name,
                }))
              }
            />
          </label>

          <label>
            <span className="label">Estoque</span>
            <SelectHookFlex
              register={register}
              control={control}
              name="stock_id"
              placeholder="Estoque"
              options={count.stock.map((item: IStock) => ({
                value: item.id,
                label: item.name,
              }))}
            />
          </label>

          <label>
            <span className="label">Período</span>
            <SelectHookFlex
              register={register}
              control={control}
              defaultValue={count?.period[0]}
              name="typedate"
              placeholder="Período"
              options={count?.period}
              isClearable={false}
            />
          </label>

          <label>
            <span className="label">De</span>
            <InputHookFlex
              register={register}
              name="start"
              placeholder="Filtrar por data inicial"
              type="date"
              disabled={periodoState?.value === 1 || !periodoState ? true : false}
              defaultValue={Format.firstDate("YYYY-MM-DD")}
            />
          </label>

          <label>
            <span className="label">Até</span>
            <InputHookFlex
              register={register}
              name="end"
              placeholder="Filtrar por data final"
              type="date"
              disabled={periodoState?.value === 1 || !periodoState ? true : false}
              defaultValue={Format.date(DateUtils.endOfMonth(), "YYYY-MM-DD")}
            />
          </label>
        </div>
      )}

      <div className="max-screen">
        <label>
          Loja
          <SelectHookFlex
            register={register}
            control={control}
            defaultValue={[]}
            name="store"
            options={
              storeMe &&
              storeMe?.user?.relationships?.stores?.map((item: IStore) => ({
                value: item.id,
                label: item.trading_name || item.company_name,
              }))
            }
          />
        </label>

        <label>
          Estoque
          <SelectHookFlex
            register={register}
            control={control}
            name="stock_id"
            options={count.stock.map((item: IStock) => ({
              value: item.id,
              label: item.name,
            }))}
          />
        </label>

        <label>
          Período
          <SelectHookFlex
            register={register}
            control={control}
            defaultValue={count?.period[0]}
            name="typedate"
            options={count?.period}
            isClearable={false}
          />
        </label>

        <label>
          De
          <InputHookFlex
            register={register}
            name="start"
            type="date"
            disabled={periodoState?.value === 1 || !periodoState ? true : false}
            defaultValue={Format.firstDate("YYYY-MM-DD")}
          />
        </label>

        <label>
          Até
          <InputHookFlex
            register={register}
            name="end"
            type="date"
            disabled={periodoState?.value === 1 || !periodoState ? true : false}
            defaultValue={Format.date(DateUtils.endOfMonth(), "YYYY-MM-DD")}
          />
        </label>
      </div>
    </S.Wrapper>
  );
}
